
const state = {
	
	appLoading: false,
	scrollTo: ""

};

const actions = {

    startLoading(context){
		context.commit("setAppLoading",true);
	},

	stopLoading(context){
		context.commit("setAppLoading",false);
	},

	addScrollTo(context, value){
		context.commit("setScrollTo", value);
	},

	clearScrollTo(context){
		context.commit("setScrollTo", "");
	},
	
}

const mutations = {
	setScrollTo(state, value){
		state.scrollTo = value;
	},
	setAppLoading(state,value){
		state.appLoading = value;
	},
}

const getters = {
	appLoading(state){
		return state.appLoading;
	},
	scrollTo(state){
		return state.scrollTo;
	}
};
  

export default {
    state,
    actions,
    mutations,
    getters
};